//@flow
import * as Immutable from 'immutable';

import { ShiftInstant } from 'common/models/flow/ShiftInstant';
import type { ShiftInstantModelType } from 'common/models/flow/ShiftInstant';
import DataUtils from 'common/utils/DataUtils';
import I18nHelper from 'common/helpers/I18nHelper';
import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import TimeUtils, { DateTimeFormat } from 'common/utils/TimeUtils';
import NumberUtils from 'common/utils/NumberUtils';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);
@validatable
class InternalShiftInstant extends ShiftInstant {
    static fromJS(json: ShiftInstantModelType): InternalShiftInstant {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setTime(time: string): this {
        return super.setTime(time);
    }

    validateTime() {
        const timeMoment = this.getDayAdjustedTimeMoment();
        if (!DataUtils.isEmpty(this.time) && !timeMoment.isValid()) {
            return nsTranslate('shiftInstant.invalidTime');
        }
    }

    @validate
    setDay(day: number): this {
        return super.setDay(day);
    }

    validateDay(): ?string {
        const { day } = this;
        if (!NumberUtils.isNumeric(day)) {
            return nsTranslate('shiftInstant.invalidDay');
        }
    }

    getDayAdjustedTimeMoment() {
        const { day, time } = this;
        const {
            FANCY_TIME_FORMAT,
            FANCY_COMPACT_TIME_FORMAT,
            HTML5_FMT_TIME
        } = DateTimeFormat;
        const inputFormat = [
            FANCY_TIME_FORMAT,
            FANCY_COMPACT_TIME_FORMAT,
            HTML5_FMT_TIME
        ];
        const momentWithEnglishLocale = TimeUtils.getMomentWithEnglishLocale(
            time,
            inputFormat,
            true
        );
        return TimeUtils.getMomentWithLocale(momentWithEnglishLocale).add(
            day - 1,
            'days'
        );
    }
}

export { InternalShiftInstant as ShiftInstant };
